export default __webpack_public_path__ + "static/media/old-design-painpoints.092080f3.png";